import React from "react";
import styled from "styled-components";
import { InputWayTextCharElement } from "common/topic/input_way_text";
import { CharacterResult } from "common/character/dto/CharacterResult";
import TextCharDelimiterNav from "../TextCharDelimiterNav/TextCharDelimiterNav";
import { isNotPopulatedCharacter } from "./TextCharEditElement.logic";
import CharacterModalLarge from "components/common/character/util/CharacterSearchSelect/CharacterModalLarge";
import { NAV_MODE } from "constant/navigation";

type TextCharEditElementProps = {
  textCharElement: InputWayTextCharElement;
  textCharInd: number;
  textCharNavActivate: boolean[][];
  navActivateToggleHandle: (tCharInd: number, elInd: number) => void;
};

const TextCharEditElement = ({
  textCharElement,
  textCharInd,
  textCharNavActivate,
  navActivateToggleHandle,
}: TextCharEditElementProps) => {
  const elementText: string = React.useMemo(
    () =>
      textCharElement.isCharacter
        ? (textCharElement.value as CharacterResult).letter
        : (textCharElement.value as string),
    [textCharElement]
  );

  const [charModalShow, setCharModalShow] = React.useState<boolean>(false);

  const handleClose = React.useCallback(() => {
    setCharModalShow(false);
  }, [setCharModalShow]);

  const elChNavClickHandle = React.useCallback(() => {
    if (textCharElement.isCharacter) {
      setCharModalShow(true);
    }
  }, [textCharElement.isCharacter, setCharModalShow]);

  const delimiterClickHandle = (ind: number) => {
    navActivateToggleHandle(textCharInd, ind);
    console.log("delimiterClickHandle", ind);
  };

  const elementChN: string[] = elementText.split("");

  return (
    <Div isCharacter={textCharElement.isCharacter}>
      {textCharElement.isCharacter && (
        <CharacterModalLarge
          initMode={NAV_MODE.EDIT}
          open={charModalShow}
          onClose={handleClose}
          title={`Update: ${elementText}`}
          character={textCharElement.value as CharacterResult}
          onUpdate={handleClose}
        />
      )}

      {elementChN.map((elementCh: string, ind: number) => (
        <>
          <TextCharDelimiterNav
            onClick={() => delimiterClickHandle(ind)}
            active={
              textCharNavActivate &&
              textCharNavActivate[textCharInd] &&
              textCharNavActivate[textCharInd][ind]
            }
          />
          <ElementChNav
            onClick={elChNavClickHandle}
            isCharacter={textCharElement.isCharacter}
            isNotPopulatedChar={isNotPopulatedCharacter(textCharElement)}
          >
            {elementCh}
          </ElementChNav>
        </>
      ))}
    </Div>
  );
};

const Div = styled.div<{ isCharacter?: boolean }>`
  margin-top: 0rem;
  display: flex;
  gap: 0.5rem;
  padding-bottom: 0.5rem;
  border-bottom: ${(props) => (props.isCharacter ? "0.3rem solid blue" : "0")};
`;

const ElementChNav = styled.span<{
  isCharacter?: boolean;
  isNotPopulatedChar?: boolean;
}>`
  cursor: pointer;
  :hover {
    opacity: 0.5;
  }
  color: ${(props) => (props.isCharacter ? "blue" : "inherit")};
  opacity: ${(props) => (props.isNotPopulatedChar ? 0.3 : 1)};
`;

export default TextCharEditElement;
